import React from 'react';
import { Box } from '@mui/material';

interface LoadingOverlayProps {
    isOpen: boolean;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ isOpen }) => {
    if (!isOpen) return null;

    return (
        <Box
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
        sx={{
            animation: 'fadeIn 0.3s ease-in-out',
        }}
    >
        <Box className="bg-white/90 backdrop-blur-sm p-8 rounded-lg shadow-xl flex flex-col items-center">
            {/* Animation SVG */}
            <div className="w-32 h-32 relative">
                {/* Cercle extérieur rotatif avec icônes */}
                <div className="absolute inset-0 animate-spin-slow">
                    <svg className="w-full h-full" viewBox="0 0 100 100">
                        <circle
                            cx="50"
                            cy="50"
                            r="45"
                            fill="none"
                            stroke="#10B981"
                            strokeWidth="2"
                            strokeDasharray="8 8"
                        />
                        {/* Icônes autour du cercle */}
                        <g className="text-emerald-500">
                            <path d="M50 5 L54 12 H46 Z" fill="currentColor"/> {/* Maison en haut */}
                            <path d="M85 50 L78 54 V46 Z" fill="currentColor"/> {/* Flèche droite */}
                            <path d="M50 95 L46 88 H54 Z" fill="currentColor"/> {/* Maison en bas */}
                            <path d="M15 50 L22 46 V54 Z" fill="currentColor"/> {/* Flèche gauche */}
                        </g>
                    </svg>
                </div>

                {/* Ampoule centrale avec pulsation */}
                <div className="absolute inset-0 flex items-center justify-center animate-pulse">
                    <svg className="w-16 h-16" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M12 2C8.13 2 5 5.13 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.87-3.13-7-7-7z"
                            className="fill-emerald-500"
                        />
                        <path
                            d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1z"
                            className="fill-emerald-600"
                        />
                        {/* Rayons lumineux avec animation */}
                        <g className="animate-pulse">
                            <path d="M12 3.5V2" stroke="#10B981" strokeWidth="0.5"/>
                            <path d="M18.5 9H20" stroke="#10B981" strokeWidth="0.5"/>
                            <path d="M4 9H5.5" stroke="#10B981" strokeWidth="0.5"/>
                            <path d="M16.5 4.5L18 3" stroke="#10B981" strokeWidth="0.5"/>
                            <path d="M7.5 4.5L6 3" stroke="#10B981" strokeWidth="0.5"/>
                        </g>
                    </svg>
                </div>
            </div>

            {/* Texte de chargement */}
            <div className="mt-4 text-center">
                <p className="text-emerald-800 font-medium text-lg mb-1">
                    Chargement en cours
                </p>
                <p className="text-emerald-600 text-sm animate-pulse">
                    Économisons l'énergie ensemble
                </p>
            </div>
        </Box>
    </Box>

    );
};

export default LoadingOverlay;